import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M13 3.5v.9H7v-.9a1 1 0 0 0-2 0v1.07A3.001 3.001 0 0 0 3 7.4v7.1a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V7.4a3.001 3.001 0 0 0-2-2.83V3.5a1 1 0 1 0-2 0ZM5 13.6V9h10v4.6a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2Z" }, null, -1)
  ])))
}
export default { render: render }